import { BsBuilding } from "react-icons/bs";
import { SguUnitsSideMenu, SguUnitMenuItem } from "../../../components/SguUnitsMenu";

const textoLimitado = (texto, limite = 30) => {
  if (!texto) return "";
  return texto.length <= limite ? texto : `${texto.slice(0, limite)}...`;
};

const NotificationMenu = ({
  user,
  units,
  onUnitSelect,
  onSearch,
  selectedUnit,
  searchValue,
  headerRight,
}) => (
  <SguUnitsSideMenu
    icon={BsBuilding}
    subtitle="Seleção"
    title="Unidades"
    headerRight={headerRight}
    sectionId="notification-unidades"
    searchValue={searchValue}
    onSearch={onSearch}
    emptyText="Nenhuma unidade encontrada"
  >
    {(units || []).map((unit) => {
      const equipmentsCount = unit?.equipments?.length || 0;
      return (
        <SguUnitMenuItem
          key={unit._id || unit.cnpj}
          active={selectedUnit?._id === unit._id}
          title={
            user?.hideSensitiveInfo
              ? "*****"
              : textoLimitado(unit.name?.toUpperCase() || "Empresa sem nome", 30)
          }
          badge={`${equipmentsCount} ${equipmentsCount === 1 ? "equip." : "equips."}`}
          meta={[
            `E-mail: ${user?.hideSensitiveInfo ? "*****" : unit?.email || "--"}`,
            `CNPJ: ${user?.hideSensitiveInfo ? "*****" : unit?.cnpj || "--"}`,
          ]}
          onClick={() => onUnitSelect(unit)}
        />
      );
    })}
  </SguUnitsSideMenu>
);

export default NotificationMenu;
